import type { VoucherListByHotelId_TopPageQuery } from "@/lib/gql/__generated__/graphql";

import { VoucherListTableRoot } from "./table/root";
import { useInitialize } from "../model/usecase/use-init/use-init";

type Props = {
	hotelID: string;
	data: VoucherListByHotelId_TopPageQuery | undefined;
};

export const MarketingVoucherPresenter = ({ hotelID, data }: Props) => {
	const {
		sellingVouchers,
		stopSellingVouchers,
		onUpdateVoucherList,
		onDeleteVoucher,
		navigateToCreateNewVoucherPage,
		navigateToDuplicateVoucherPage,
		navigateToEditVoucherPage,
	} = useInitialize({
		hotelID,
		data,
	});

	return (
		<VoucherListTableRoot
			hotelID={hotelID}
			sellingVouchers={sellingVouchers}
			stopSellingVouchers={stopSellingVouchers}
			onDeleteVoucher={onDeleteVoucher}
			onUpdateVoucherList={onUpdateVoucherList}
			navigateToCreateNewVoucherPage={navigateToCreateNewVoucherPage}
			navigateToDuplicateVoucherPage={navigateToDuplicateVoucherPage}
			navigateToEditVoucherPage={navigateToEditVoucherPage}
		/>
	);
};

MarketingVoucherPresenter.displayName = "MarketingVoucherPresenter";
